import { Box, Button, FormControl, TextField } from '@mui/material';
import React, { useState } from 'react';
import axios from 'axios';

import { APIBASEURL } from '../../config/settings';
import authHeader from '../../services/auth-header';
import '../newcoach/coach_style.css';

const HASH_URL = `${APIBASEURL}/api/auth/hash`;

const AdminTool = () => {
    const [originPass, setOriginPass] = useState('');
    const [encrypted, setEncrypted] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const handleEncrypt = async () => {
        setError('');
        setLoading(true);
        try {
            const { data } = await axios.post(
                HASH_URL,
                { password: originPass },
                { headers: authHeader() }
            );
            setEncrypted(data.hash || '');
        } catch (err) {
            setError(err.response?.data?.message || 'Failed to hash');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Box sx={{ width: '100%', padding: '24px', display: 'flex', alignItems: 'center', gap: '24px' }}>
            <FormControl sx={{ gap: '4px' }}>
                <p className="normal-text" style={{ color: '#ffffff' }}>
                    Origin Password
                </p>
                <TextField
                    value={originPass}
                    label=""
                    inputProps={{ 'aria-label': 'Without label' }}
                    variant="outlined"
                    placeholder="Write password to encrypt here"
                    onChange={(e) => setOriginPass(e.target.value)}
                    sx={{ borderRadius: '10px', height: '48px', width: '400px', '& legend': { display: 'none' }, '& fieldset': { top: 0 } }}
                />
            </FormControl>
            <Button variant="outlined" onClick={() => handleEncrypt()} disabled={loading || !originPass}>{loading ? '…' : '>>'}</Button>
            <FormControl sx={{ gap: '4px' }}>
                <p className="normal-text" style={{ color: '#ffffff' }}>
                    Encrypted Password
                </p>
                <TextField
                    value={encrypted}
                    label=""
                    inputProps={{ 'aria-label': 'Without label' }}
                    variant="outlined"
                    placeholder="Encrypted password"
                    sx={{ borderRadius: '10px', height: '48px', width: '500px', '& legend': { display: 'none' }, '& fieldset': { top: 0 } }}
                />
            </FormControl>
            {error && <p style={{ color: 'red' }}>{error}</p>}
        </Box>
    );
};

export default AdminTool;
